
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.en.md?watch=parent';
    export const toc = [{"id":"code-example","depth":3,"title":"Code Example"}];
export const frontmatter = {"title":"Map","toc":"content","filename":"src/Map/index.en.md","atomId":"Map","lastUpdated":1769581795000,"order":1,"group":{"order":2,"title":"Maps"},"debug":true};